import React, { Component } from 'react'

import Bullet from '../utilities/bullet'

class Faq extends Component {

    constructor(props) {
        super(props)
        this.state = {
            accento: '',
            faq: ''
        }
    }

    componentDidMount() {
        this.setState({
            accento: this.props.sito.coloreAccento || '#03a9f4',
            faq: this.props.sito.faq || ''
        })
    }

    render() {

        return (
            <div id="faq" className="uk-section uk-section-muted uk-section-large">
                <div className="uk-container">
                    <div className="uk-clearfix">
                        <h2 className="uk-margin uk-text-bold uk-text-uppercase">
                            <Bullet colore={this.state.accento} />FAQ
                            </h2>
                    </div>

                    <div className="uk-margin-small-top">

                            {this.state.faq.split('\n').map((item, key) =>
                            <div key={key} >
                                <p className={key % 2 ? "" : "uk-text-lead"}>
                                    {item}
                                </p>
                                {key % 2 ? <div className="uk-margin-medium" /> : null }
                                </div>
                            )}

                    </div>
                </div>
            </div>
        )
    }
}

export default Faq


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/faq/index.js